import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { setWechatTitle } from '../utils/wechatTitle';
import { Image as AntdImage, Button } from 'antd-mobile';
import FloatBackButton from '../components/FloatBackButton';
import { useWechatShare } from '../utils/wechatShare';

const SpecialtiesPage = () => {
  const navigate = useNavigate();
  // 大图控制
  const [isFullscreen, setIsFullscreen] = useState(false);
  const transformRef = useRef(null);
  const containerRef = useRef(null); 

  // 图片地址
  const imageUrl = `${window.location.origin}/images/specialty_mini.png`;
  const bigImageUrl = `${window.location.origin}/images/specialty_big_rotate90.png`;
  // const imageUrl = `https://resources.eos-dongguan-1.cmecloud.cn/agri/specialty_mini.png`;
  // const bigImageUrl = `https://resources.eos-dongguan-1.cmecloud.cn/agri/specialty_big_rotate90.png`;


  // 缩放控制方法
  // const handleZoomIn = () => {
  //   transformRef.current?.zoomIn(0.2);
  // };

  // const handleZoomOut = () => {
  //   transformRef.current?.zoomOut(0.2);
  // };

  // const handleReset = () => {
  //   transformRef.current?.resetTransform();
  // };

  // 核心：重置并重新计算居中（统一逻辑）
  const resetAndCenter = useCallback(() => {
    const transformInstance = transformRef.current;
    const container = containerRef.current;
    if (!transformInstance || !container) return;

    // 1. 重置到初始状态（清除所有位置/缩放记忆）
    transformInstance.resetTransform();

    // 2. 强制基于当前容器尺寸重新计算居中（关键步骤）
    const containerRect = container.getBoundingClientRect();
    transformInstance.centerView({
      x: containerRect.width / 2,   // 容器水平中心
      y: containerRect.height / 2,  // 容器垂直中心
      duration: 0 // 无动画，瞬间居中
    });
  }, []);

  // 预加载大图
  useEffect(() => {
    const preloadImages = async () => {
      const img = new Image();
      img.src = imageUrl;
      await new Promise(resolve => {
        img.onload = resolve;
        img.onerror = resolve;
      });
      
      const img2 = new Image();
      img2.src = bigImageUrl;
      await new Promise(resolve => {
        img2.onload = resolve;
        img2.onerror = resolve;
      });
    };

    preloadImages();
  }, [imageUrl, bigImageUrl]);

  // 设置页面标题
  useEffect(() => {
    setWechatTitle("珠海土特产");
  }, []);

  // 微信分享配置
  useWechatShare(
    '珠海土特产一张图',
    '探索珠海特色美食，不容错过的本地特产',
    imageUrl
  );

  // 关闭时重置
  useEffect(() => {
    // if (!isFullscreen) {
    //   imgOffset.current = { x: 0, y: 0 };
    //   if (imgRef.current) {
    //     imgRef.current.style.transform = 'rotate(90deg) scale(0.3) translate(0, 0)';
    //   }
    // }
  }, [isFullscreen]);
  
  return (
    <div className="min-h-screen flex flex-col">
      {/* <Header title="乡村文旅" /> */}
      <div className="px-4 py-2" ><FloatBackButton onClick={() => navigate('/')} /></div>
      
      <div className="flex-1 px-4 py-2">
        <div className="">
          <AntdImage 
            src={imageUrl}
            alt="珠海土特产一张图"
            style={{ width: '100%', borderRadius: '8px' }}
          />

          <div className="p-6 text-center">
            <button
              onClick={() => setIsFullscreen(true)}
              className="font-bold py-2 px-8 rounded-lg border-none text-lg"
              style={{ backgroundColor: '#facd91', color: '#0000FF', display: 'inline-flex', gap: 8, alignItems: 'center'  }}
            >
              <img src="/images/look_big_img.png" alt="查看大图" className="w-5 h-5 " 
                style={{ marginBottom: 2}}
              />
              查看大图
            </button>
          </div>
        </div>
      </div>

      {/* 大图区域（调大初始显示尺寸） */}
      <div className={`image-container bg-f2f2f2 ${isFullscreen ? 'fullscreen' : 'visibility-hidden'}`}
        
        ref={containerRef}
        style={{ 
          // height: imageContainerHeight, // 关键：动态高度
          minHeight: 0 // 避免 flex 布局冲突
        }}
      >
        <TransformWrapper
          ref={transformRef}
          initialScale={1.8} // 初始缩放比例调大（默认1 → 1.2，放大20%）
          minScale={1}    // 最小缩放也适当调大（避免缩得太小）
          maxScale={3}      // 最大缩放保持不变
          centerOnInit      // 保持初始居中
        >
          <TransformComponent>
            {/* 大图：通过基础样式进一步放大初始尺寸 */}
            <img
              src={bigImageUrl}
              className="large-image"
              style={{
                width: '100%', // 基础宽度调大（默认100% → 110%）
                maxWidth: 'none' // 确保不受父容器宽度限制
              }}
              onError={(e) => {
                console.error('背景图加载失败！路径：', bigImageUrl);
                e.target.alt = '背景图加载失败';
              }}
            />
          </TransformComponent>
        </TransformWrapper>
        <Button 
          shape="circle" 
          size="large" 
          className="back-button"
          onClick={() => {setIsFullscreen(prev => !prev);resetAndCenter();}}
          
        >
              <div className="button-content">
                <img src='/images/back_icon.png' alt='返回' 
                // className='w-5 h-5' 
                style={{ 
                  width: 22, 
                  height: 22,
                //   marginBottom: 3,
                  filter: 'brightness(0) invert(1)'}} />
              <span>返回</span>
              </div>
        </Button>
      </div>
    </div>
  );
};

export default SpecialtiesPage;